import React from 'react';
import { Modal, Button } from '@/components/common';
import { FaExclamationTriangle } from 'react-icons/fa';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  roomName: string;
  isLoading: boolean;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  roomName,
  isLoading
}) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      // Error handling is done by parent component
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Island" className="border-game-orange">
      <div className="space-y-6">
        {/* Warning Message */}
        <div className="p-4 bg-game-orange/20 border border-game-orange/50 text-game-accent rounded-lg">
          <div className="flex items-start gap-3">
            <FaExclamationTriangle className="text-game-golden flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium mb-2">Are you sure you want to delete this island?</p>
              <p className="text-sm">
                Island: <strong className="text-white">"{roomName}"</strong>
              </p>
              <p className="text-sm mt-2 text-game-golden">
                This action cannot be undone and all island data will be permanently lost.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm} isLoading={isLoading}>
            Delete Island
          </Button>
        </div>
      </div>
    </Modal>
  );
};